import { compose, defaultProps } from "recompact"
import { connect } from "react-redux"
import resourceTypeModel from "src/models/resourceType"
import entityList from "src/hocs/entityList"
import EntityListEditor from "src/components/EntityListEditor"
import {
  RESOURCE_TYPE_CREATE,
  RESOURCE_TYPE_UPDATE,
  RESOURCE_TYPE_DELETE,
} from "src/constants/knownPermissions"
import { hasPermission } from "src/engine/modules/currentUser"
import { RESOURCE_TYPES_URL } from "src/constants/routeNames"
import queryString from "query-string"
import Item, { FORM_NAME } from "./Item"

const closeModalOnComplete = ({ history, queryParams, workspace }) => () => {
  function closeModal(labels) {
    /* Close the modal window only if there are no errors downer */
    if (!labels.error) {
      history.push(
        `${RESOURCE_TYPES_URL}?${queryString.stringify(queryParams)}`,
      )
    }
  }

  if (workspace.labels.pending) {
    /* We should wait when pending will be completed */
    const updateHandler = ({ labels }) => {
      if (!labels.pending) {
        workspace.uncapture(`workspace-update`, updateHandler)

        closeModal(labels)
      }
    }
    workspace.capture(`workspace-update`, updateHandler)
  } else {
    closeModal(workspace.labels)
  }
}

const columns = [
  {
    Header: `Наименование типа ресурса`,
    accessor: `name`,
    sortable: true,
    resizable: false,
  },
]

const enhancer = compose(
  entityList({
    model: resourceTypeModel,
    ITEM_FORM_NAME: FORM_NAME,
    baseUri: RESOURCE_TYPES_URL,
    columns,
  }),
  defaultProps({
    EntityEditor: compose(
      defaultProps({
        onUpdate: closeModalOnComplete,
      }),
      connect(state => ({
        disableEdit: !hasPermission(RESOURCE_TYPE_UPDATE)(state),
      })),
    )(Item),
    isOnlySearchInputFilter: true,
    fullWidth: true,
    fullHeight: true,
    noFooter: true,
  }),
  connect(state => ({
    disableCreate: !hasPermission(RESOURCE_TYPE_CREATE)(state),
    disableEdit: !hasPermission(RESOURCE_TYPE_UPDATE)(state),
    disableDelete: !hasPermission(RESOURCE_TYPE_DELETE)(state),
  })),
)

export default enhancer(EntityListEditor)
